import { MiniSitesConstants } from "../constants/MiniSitesConstants";
/**
 * region for hepers*/
import typing from '../helpers/typing';

const initialState = {
    backoffficeUrl: "",
    save: false,
    reload: false,
    pending: false,
    error: null,
    activeStep: 0,
    idMinisite: 0,
    dataBasicDetails: {
        name: "",
        subdomain: "",
        domain: "",
        domainName: "",
        minisiteLogoUrl: "",
        minisiteLogo: null,
        errors: {
            name: false,
            subdomain: false,
            domain: false
        }
    },
    dataSelectContent: {
        selectListEvents: [],
        selectListEventsNew: [],
        errors: {
            selectListEvents: false
        }
    },
    dataNotofications: {
        header: "",
        footer: "",
        errors: {
            header: false,
            footer: false
        }
    },
    dataNotificationContent: {
        selectListNotifications: [],
        errors: {
            selectListNotifications: false
        }
    },
    searchResultListEventsNew: [],
    searchResultListEvents: {},/*quitar*/
    searchResultListNotifications: [],
    selectListDomain: {},
    selectListMinisite: {},

};

export default function MiniSitesReducers(state = initialState, action) {
    switch (action.type) {
        case MiniSitesConstants.FETCH_MINI_SITES_RELOAD_COMPONENT:
            return {
                ...state,
                reload: action.payload
            }
        case MiniSitesConstants.FETCH_MINI_SITES_RELOAD_STOP_COMPONENT:
            return {
                ...state,
                reload: action.payload
            }
        case MiniSitesConstants.FETCH_MINI_SITES_PENDING:
            return {
                ...state,
                pending: true
            }
        case MiniSitesConstants.FETCH_MINI_SITES_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error
            }
        case MiniSitesConstants.FETCH_MINI_SITES_GET_LIST_DOMAIN_SUCCESS:
            return {
                ...state,
                pending: false,
                selectListDomain: action.payload
            }
        case MiniSitesConstants.FETCH_MINI_SITES_GET_ISVALID_SUBDOMAIN_SUCCESS:
            return {
                ...state,
                pending: false,
                activeStep: state.activeStep + action.activeStep,
            }
        case MiniSitesConstants.FETCH_MINI_SITES_GET_ISVALID_SUBDOMAIN_INVALID:
            let obj = Object.assign({}, state.dataBasicDetails);
            obj.errors.domain = true;
            obj.errors.subdomain = true;
            return {
                ...state,
                pending: false,
                activeStep: state.activeStep + action.activeStep,
                dataBasicDetails: obj
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES:
            return {
                ...state,
                pending: false,
                dataBasicDetails: action.payload
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES_HTML:
            return {
                ...state,
                pending: false,
                dataNotofications: action.payload
            }
        case MiniSitesConstants.FETCH_MINI_SITES_GET_LIST_EVENTS_SUCCESS:
            return {
                ...state,
                pending: false,
                searchResultListEvents: action.payload
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_EVENTS_SUCCESS:
            return {
                ...state,
                pending: false,
                dataSelectContent: action.payload,
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SET_ACTIVE_STEP:
            return {
                ...state,
                dataBasicDetails: action.payload,
                activeStep: action.activeStep,
                reload: false
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SAVE_SUCCESS:
            return {
                ...state,
                idMinisite: 0,
                dataBasicDetails: {
                    name: "",
                    subdomain: "",
                    domain: "",
                    domainName: "",
                    minisiteLogoUrl: "",
                    minisiteLogo: null,
                    errors: {
                        name: false,
                        subdomain: false,
                        domain: false
                    }
                },
                dataSelectContent: {
                    selectListEvents: [],
                    selectListEventsNew: [],
                    errors: {
                        selectListEvents: false
                    }
                },
                dataNotofications: {
                    header: "",
                    footer: "",
                    errors: {
                        header: false,
                        footer: false
                    }
                },
                dataNotificationContent: {
                    selectListNotifications: [],
                    errors: {
                        selectListNotifications: false
                    }
                },
                pending: false,
                save: action.payload,
                activeStep: 0
            }
        case MiniSitesConstants.FETCH_MINI_SITES_GET_BACKOFFICE_URL_SUCCESS:
            return {
                ...state,
                backoffficeUrl: action.payload
            }
        case MiniSitesConstants.FETCH_MINI_SITES_GET_LIST_MINISITES_SUCCESS:
            return {
                ...state,
                pending: false,
                selectListMinisite: action.payload,
            }
        case MiniSitesConstants.FETCH_MINI_SITES_GET_MINISITE_SUCCESS:
            let listEvents = [];

            action.payload.EVENTSLIST.forEach(function (item) {
                listEvents.push({ ID: item.IDEVENT, TEXT: item.TITLE });
            });

            let listNotifications = [];
            action.payload.MANDRILLTEMPLATELIST.forEach(function (item) {
                listNotifications.push({ ID: item.IDTEMPLATE, TEXT: item.SLUG });
            });

            var domains = state.selectListDomain.data;
            let domain2 = "";
            let subdomain2 = "";
            if (typing.isDefined(domains)) {
                domains.forEach(function (x) {
                    if (action.payload.DOMAIN_NAME.includes("." + x.DOMAIN)) {
                        domain2 = x.DOMAIN;
                        subdomain2 = action.payload.DOMAIN_NAME.substring(0, action.payload.DOMAIN_NAME.indexOf(x.DOMAIN) - 1);
                        return;
                    }
                });
            }

            let header = "";
            if (typing.isDefined(action.payload.HEADER_MINISITE)) {
                header = action.payload.HEADER_MINISITE;
            }

            let footer = "";
            if (typing.isDefined(action.payload.FOOTER_MINISITE)) {
                footer = action.payload.FOOTER_MINISITE;
            }

            return {
                ...state,
                save: false,
                pending: false,
                idMinisite: action.payload.IDMINISITE,
                dataBasicDetails: {
                    name: action.payload.NAME,
                    subdomain: subdomain2,
                    domainName: action.payload.DOMAIN_NAME,
                    domain: domain2,
                    minisiteLogoUrl: action.payload.LOGO,
                    minisiteLogo: null,
                    errors: {
                        name: false,
                        subdomain: false,
                        domain: false
                    }
                },
                dataSelectContent: {
                    selectListEvents: [],
                    selectListEventsNew: listEvents,
                    errors: {
                        selectListEvents: false
                    }
                },
                dataNotificationContent: {
                    selectListNotifications: listNotifications,
                    errors: {
                        selectListNotifications: false
                    }
                },
                dataNotofications: {
                    header: header,
                    footer: footer,
                    errors: {
                        header: false,
                        footer: false
                    }
                }
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SEARCH_EVENTS_SUCCESS:
            let listSearchEvents = [];
            action.payload.forEach(function (item) {
                listSearchEvents.push({ ID: item.IDEVENT, TEXT: item.TITLE });
            });

            return {
                ...state,
                pending: false,
                searchResultListEventsNew: listSearchEvents
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_EVENT:
            return {
                ...state,
                pending: false,
                dataSelectContent: {
                    selectListEvents: [],
                    selectListEventsNew: action.payload,
                    errors: {
                        selectListEvents: action.errors
                    }
                },
                searchResultListEventsNew: action.payload2,
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SEARCH_NOTIFICATIONS_SUCCESS:
            let listNotificationsDefault = [];
            action.payload.forEach(function (item) {
                listNotificationsDefault.push({ ID: item.IDTEMPLATE, TEXT: item.SLUG });
            });

            return {
                ...state,
                pending: false,
                searchResultListNotifications: listNotificationsDefault
            }
        case MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_NOTIFICATIONS:
            return {
                ...state,
                pending: false,
                dataNotificationContent: {
                    selectListNotifications: action.payload,
                    errors: {
                        selectListNotifications: action.errors
                    }
                },
                searchResultListNotifications: action.payload2,
            }
        case MiniSitesConstants.FETCH_MINI_SITES_UPDATE_SUCCESS:
            return {
                ...state,
                idMinisite: 0,
                dataBasicDetails: {
                    name: "",
                    subdomain: "",
                    domain: "",
                    domainName: "",
                    minisiteLogoUrl: "",
                    minisiteLogo: null,
                    errors: {
                        name: false,
                        subdomain: false,
                        domain: false
                    }
                },
                dataSelectContent: {
                    selectListEvents: [],
                    selectListEventsNew: [],
                    errors: {
                        selectListEvents: false
                    }
                },
                dataNotofications: {
                    header: "",
                    footer: "",
                    errors: {
                        header: false,
                        footer: false
                    }
                },
                dataNotificationContent: {
                    selectListNotifications: [],
                    errors: {
                        selectListNotifications: false
                    }
                },
                pending: false,
                save: true,
            }
        case MiniSitesConstants.FETCH_MINI_SITES_GET_ISVALID:
            let obj1 = Object.assign({}, state.dataBasicDetails);
            obj1.errors.domain = true;
            obj1.errors.subdomain = true;
            return {
                ...state,
                pending: false,
                dataBasicDetails: obj1
            }
        case MiniSitesConstants.FETCH_MINI_SITES_CLEAR:
            return {
                ...state,
                pending: false,
                save: false,
                idMinisite: 0,
                dataBasicDetails: {
                    name: "",
                    subdomain: "",
                    domain: "",
                    domainName: "",
                    minisiteLogoUrl: "",
                    minisiteLogo: null,
                    errors: {
                        name: false,
                        subdomain: false,
                        domain: false
                    }
                },
                dataSelectContent: {
                    selectListEvents: [],
                    selectListEventsNew: [],
                    errors: {
                        selectListEvents: false
                    }
                },   
                dataNotofications: {
                    header: "",
                    footer: "",
                    errors: {
                        header: false,
                        footer: false
                    }
                },
                dataNotificationContent: {
                    selectListNotifications: [],
                    errors: {
                        selectListNotifications: false
                    }
                },
                activeStep: 0
            }
        default:
            return state
    }
}